import React, { Component } from "react";
import FakeData from ".././fake-data";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Home.css";

import Media from "react-media";

import {
	UpcominComingGames,
	LiveGames,
	PostItem,
	EmptyState,
	LoadingState,
	GlobalTMFeeds,
	GlobalTMForm,
	LeagueSplitView,
	ConfirmModal,
	ItemPicker,
	Modal,
	ComboBox,
	PhotoAddModal,
	TagView,
	MomentPickerModal,
	EditGameModal,
	PublicityPicker
} from ".././components/Common";
import {
	EventViewCreateForm1,
	EventGroupChatCreate,
	LocationPicker
} from ".././components/Event";
import Avatar from ".././components/Avatar";
import {
	UserKnowledgeGraph,
	TeamKnowledgeGraph,
	GroupKnowledgeGraph,
	TournKnowledgeGraph,
	ClubKnowledgeGraph,
	InstitutionKnowledgeGraph
} from "./Search";
import { ChatView, ChatList } from "./Chat";
import VideoStreamTV, { VideoPlayer } from "../components/VideoStreamTV";

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;

export default class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: { id: null },
			activeView: "Timeline",
			currentUser: { id: null },
			currentFilter: "",
			isShowinQuickLinks: false,
			isGoingLive: false,
			currentView: "Friends",
			createLinks: [
				{ to: { pathname: "/create/club" }, key: "Club" },
				{ to: { pathname: "/create/education_profile" }, key: "Institution" },
				{ to: { pathname: "/gmc" }, key: "Game" },
				{ to: { pathname: "/create/team" }, key: "Team" },
				{ to: { pathname: "/create/tournament" }, key: "Tournament" }
			],
			isDeletingSC: false,
			shortCutToDel: null,
			isAddingEvent: false,
			isAddingNormalEvent: false,
			eventType: null,
			isAddingGroup: false,
			posts: [],
			isLoadingPosts: true,
			groups: [],
			shortcuts: [],
			limit: 30,
			offset: 0,
			game: { timestamp: "0000-00-00 00:00:00" },
			d: 0,
			h: 0,
			m: 0,
			s: 0,
			chat: {
				filters: ["All", "Chats", "Groups", "Teams", "Parents", "Emails"],
				activeFilter: "All",
				isCreateChat: false,
				chat: null,
				chats: [],
				rawChats: [],
				emails: [],
				activeChatIndex: 0,
				isLoading: true
			}
		};

		this.onPostAdded = this.onPostAdded.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.setFilters = this.setFilters.bind(this);
		this.onChatSelect = this.onChatSelect.bind(this);
		this.onUserSelect = this.onUserSelect.bind(this);
		this.setCreatingChatView = this.setCreatingChatView.bind(this);
	}

	componentWillMount() {
		window.addEventListener("scroll", this.onScroll);
		const s = new Trojan.style("league").kill();
		FakeData.mountState("home", true);
		this.getUserData();
		//this.getPosts()
	}

	componentDidMount() {
		this._isMounted = true;
		this.countDown();
		this.getNextGame();
		this.getShortcuts();
		this.getGroups();
		this.initSystem();
	}

	getNextGame() {
		const _that = this;
		if (!FakeData.isMounted("home")) {
			return;
		}

		this.setState({
			game: FakeData.getData("nextGame")
				? FakeData.getData("nextGame")
				: { timestamp: "0000-00-00 00:00:00" }
		});
		setTimeout(() => {
			_that.getNextGame();
		}, 1000);
	}

	countDown() {
		const _that = this;
		if (!FakeData.isMounted("home")) {
			return;
		}
		if (this.state.game.timestamp === "0000-00-00 00:00:00") {
			setTimeout(() => {
				_that.countDown();
			}, 1000);
			return;
		}

		const timestamp = new Date(this.state.game.timestamp).getTime();
		var now = Date.now();
		var distance = timestamp - now;

		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor(
			(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);

		this.setState({
			d: days,
			h: hours,
			m: minutes,
			s: seconds
		});

		if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
			//remind gmc admin
			this.setState({ game: { timestamp: "0000-00-00 00:00:00" } });
		} else {
			setTimeout(() => {
				_that.countDown();
			}, 1000);
		}
	}

	componentWillUnmount() {
		const s = new Trojan.style("league").kill();
		FakeData.mountState("home", false);
		this._isMounted = false;
		if (this.system) {
			this.system.close()
		}
		document
			.querySelector("#root")
			.removeEventListener("scroll", this.onScroll);
	}

	onPostAdded(post) {
		//console.log(this.state.posts.length);
		this.state.posts.unshift(post);
		this.setState({
			posts: this.state.posts
		});
	}

	getUserData() {
		const _that = this;
		if (!FakeData.isMounted("home")) {
			return;
		}
		_that.setState({ user: FakeData.getData("yoo") });
		setTimeout(() => {
			_that.getUserData();
		}, 1500);
	}

	getPosts() {
		const _that = this;
		const dataTo = {
			user: this.state.user,
			userTo: {
				id: this.state.user.id,
				type: "P"
			},
			clubs: FakeData.listify(FakeData.getData("clubIds")),
			leagues: FakeData.listify(FakeData.getData("leagueIds")),
			teams: FakeData.listify(FakeData.getData("teamIds")),
			inst: FakeData.listify(FakeData.getData("instIds")),
			friends: FakeData.listify(FakeData.getData("friendIds")),
			limit: this.state.limit
		};

		FakeData.post("/getTest.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("home")) {
					return;
				}
				_that.setState({
					posts: res,
					isLoadingPosts: false
				});

				_that.getPostsID = setTimeout(() => {
					_that.getPosts();
				}, 1000);
			},
			error: err => {
				console.log(err);
			}
		});
	}

	getGroups() {
		///getLiveGames.php?auth0
		const _that = this;
		const dataTo = {
			userId: this.state.user.id
		};

		FakeData.post("/getGroupForums.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("home")) {
					return;
				}
				_that.setState({
					groups: res
				});

				setTimeout(() => {
					_that.getGroups();
				}, 1000);
			},
			error: err => {
				console.log(err);
				setTimeout(() => {
					_that.getGroups();
				}, 10000);
			}
		});
	}

	onScroll(e) {
		this.setState({
			offset: document.querySelector("#root").scrollTop
		});
	}

	setStyle = style => {
		const s = new Trojan.style("_home").declare(style).run();
	};

	getShortcuts = () => {
		//getUserShortcuts.php
		const _that = this;
		const dataTo = {
			userId: this.state.user.id,
			userType: "F"
		};

		FakeData.post("/getUserShortcuts.php?auth0", dataTo, {
			success: res => {
				if (!FakeData.isMounted("home")) {
					return;
				}
				_that.setState({
					shortcuts: res
				});

				_that.getPostsID = setTimeout(() => {
					_that.getShortcuts();
				}, 1000);
			},
			error: err => {
				console.log(err);
			}
		});
	};

	deleteShortcut(data) {
		const _that = this;
		const dataTo = {
			id: data.id
		};

		FakeData.post(
			"/deleteShortcut.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isDeletingSC: false,
						shortCutToDel: null
					});
					if (res.error) {
						FakeData.alert("Please try again later!");
					} else {
						FakeData.alert("Done!");
					}
				},
				error: err => {
					FakeData.alert("Please try again later!");
				}
			},
			true,
			"",
			a => { }
		);
	}

	setCurrentView = (txt = "Friends") => {
		const { chat, activeView } = this.state;
		this.setState({ currentView: txt, color: "" });
		if (activeView === "Chats") {
			const filter =
				txt === "Friends" ? "Chats" : txt === "Chat Groups" ? "Groups" : txt;
			chat.activeFilter = filter;
			this.setState({ chat });
		}
	};

	getTeams = () => {
		const { teamsFollowed, ownTeams, myTeams } = FakeData.getData("yoo");
		const list = [];

		FakeData.listify(teamsFollowed).forEach((item, i) => {
			const _teams = list.filter((_item, _i) => {
				return _item.id == item.id;
			});
			if (_teams.length === 0) {
				list.push(item);
			}
		});

		FakeData.listify(ownTeams).forEach((item, i) => {
			const _teams = list.filter((_item, _i) => {
				return _item.id == item.id;
			});
			if (_teams.length === 0) {
				list.push(item);
			}
		});

		FakeData.listify(myTeams).forEach((item, i) => {
			const _teams = list.filter((_item, _i) => {
				return _item.id == item.id;
			});
			if (_teams.length === 0) {
				list.push(item);
			}
		});

		return list;
	};

	onUserSelect(user, isGroup) {
		const { chat } = this.state;
		const chats = this.state.chat.rawChats;
		let bool = false;

		chats.forEach((item, i) => {
			if (
				!item.isGroup &&
				item.otherUser.id === user.id &&
				item.type !== "event"
			) {
				bool = true;
				chat.chat = item;
				chat.activeChatIndex = item.id;
				chat.isCreateChat = false;
				this.setState({
					chat
				});
			}
		});

		if (!bool) {
			const _chat = {
				otherUser: user,
				id: null,
				userOne: FakeData.getData("yoo"),
				userTwo: user,
				messages: [],
				last_msg: null,
				unread: 0,
				isYou: true,
				date: null,
				removedByUserOne: false,
				removedByUserTwo: false,
				type:
					chat.activeFilter === "Parents"
						? "parent"
						: FakeData.inArray(chat.activeFilter, ["Groups", "Teams"])
							? "event"
							: "timeline",
				target: "new"
			};

			chat.chat = _chat;
			chat.isCreateChat = false;

			this.setState({
				chat
			});
		}
	}

	onChatSelect(_chat) {
		const { chat } = this.state;
		chat.chat = _chat;
		chat.activeChatIndex = _chat.id;
		chat.isCreateChat = false;
		this.setState({ chat });
	}

	getChatById(id, user) {
		const { chat } = this.state;
		const chats = this.state.chat.rawChats;
		let bool = false;
		chats.forEach((item, i) => {
			if (item.id === id) {
				bool = true;
				chat.chat = item;
				chat.activeChatIndex = item.id;
				this.setState({
					chat
				});
			}
		});

		if (!bool) {
			const _chat = {
				otherUser: user,
				id: null,
				userOne: FakeData.getData("yoo"),
				userTwo: user,
				messages: [],
				last_msg: null,
				unread: 0,
				isYou: true,
				date: null,
				removedByUserOne: false,
				removedByUserTwo: false,
				type: "timeline",
				target: "new"
			};

			chat.chat = _chat;

			this.setState({
				chat
			});
		}
	}

	setCreatingChatView = (bool = true) => {
		const { chat } = this.state;
		chat.isCreateChat = bool;
		this.setState({ chat });
	};

	setFilters(filter) {
		const _that = this;
		const { chat } = this.state;
		chat.activeFilter = filter;
		this.setState({
			chat
		});
	}

	getChats() {
		const _that = this;
		const { chat } = this.state;
		const dataTo = {
			user: FakeData.getData("yoo"),
			teams: []
		};

		if (!this._isMounted) {
			return;
		}

		FakeData.post("/getChats.php?auth0", dataTo, {
			success: res => {
				//console.log(res)
				if (!_that._isMounted) {
					return;
				}
				chat.rawChats = res;
				chat.isLoading = false;
				_that.setState({
					chat
				});

				setTimeout(() => {
					_that.getChats();
				}, 1000);
			},
			error: err => {
				//console.log(err)
			}
		});
	}

	initSystem = () => {
		const { chat } = this.state;
		if (EventSource) {
			this.system = new EventSource(
				FakeData.fetchURL +
				"/getChats.php?auth0&isStream&userId=" +
				FakeData.getData("yoo").id +
				"&userType=F"
			);
			const _that = this;
			if (this.system !== null) {
				//this.system.addEventListener()
				this.system.onmessage = function (e) {
					if (_that._isMounted) {
						this.setState({
							// _that: JSON.parse(e.data)
						});
					}
				};

				this.system.addEventListener(
					"open",
					function (e) {
						// Connection was opened.
						//console.log(e)
					},
					false
				);

				this.system.addEventListener(
					"chats_update",
					function (e) {
						// Connection was opened.
						if (_that._isMounted) {
							chat.rawChats = JSON.parse(e.data);
							chat.isLoading = false;
							_that.setState({
								chat
							});
						}
					},
					false
				);

				this.system.addEventListener(
					"error",
					function (e) {
						if (e.readyState == EventSource.CLOSED) {
							// Connection was closed.
						}
					},
					false
				);
			}
		} else {
			console.warn("EventSource Streams not supoorted by browser");
			this.getChats();
		}
	};

	setChat = (_chat) => {
		const { chat } = this.state;
		let chats = chat.rawChats;
		chats.forEach((item, i) => {
			if (item.id === _chat.id) {
				chats[i] = _chat;
				chat.rawChats = chats
				this.setState({ chat })
			};
		})
	}

	_Chats = () => {
		const { chat } = this.state;
		const chats = this.state.chat.rawChats;
		let arr = [];
		if (chat.activeFilter === "All") {
			arr = chats;
		} else if (chat.activeFilter === "Chats") {
			arr = chats.filter((item, i) => {
				return !item.isGroup;
			});
		} else if (chat.activeFilter === "Groups") {
			arr = chats.filter((item, i) => {
				return item.isGroup;
			});
		} else if (
			chat.activeFilter === "Events" ||
			chat.activeFilter === "Teams"
		) {
			arr = chats.filter((item, i) => {
				return item.otherUser.isTeam;
			});
		} else if (chat.activeFilter === "Parents") {
			arr = chats.filter((item, i) => {
				return item.otherUser.isParent;
			});
		} else if (chat.activeFilter === "Emails") {
			arr = chat.emails;
		}

		return arr;
	};

	renderMidView = () => {
		const {
			user,
			isGoingLive,
			isShowinQuickLinks,
			currentFilter,
			currentView,
			currentUser,
			createLinks,
			posts,
			groups,
			offset,
			shortcuts,
			isDeletingSC,
			shortCutToDel,
			isAddingEvent,
			isAddingNormalEvent,
			eventType,
			isAddingGroup,
			activeView
		} = this.state;
		const {
			chat,
			activeFilter,
			isLoading,
			isCreateChat,
			activeChatIndex
		} = this.state.chat;

		return[
			<div key={"one"} className="home-page-mid-controls">
				{["Timeline", "Chats", "Video"].map((item, i) => {
					return (
						<span
							key={item}
							className={activeView === item ? "active" : ""}
							onClick={() => {
								if (item !== "Video") {
									this.setState({
										activeView: item,
										isShowinQuickLinks: false
									});
									this.setCurrentView();
								} else {
									this.setState({ isGoingLive: true });
								}
							}}
						>
							{item}
						</span>
					);
				})}
			</div>,
			<div key={"two"}
				style={{
					display: activeView !== "Chats" ? "block" : "none",
					width: "100%"
				}}
			>
				<GlobalTMForm words={() => {
					return []
				}}
					profile={FakeData.getData("yoo")}
					key={"timeline-form"}
					label={"Share"}
					style={{ marginTop: 0, marginBottom: "10px" }}
					user={user}
					userType={"F"}
					isAdmin={user.isAdmin}
					onPostAdded={this.onPostAdded}
					postToType="P"
					postToId={user.id}
					postToName={user.name}
					postToImage={user.image}
				/>
				<GlobalTMFeeds profile={FakeData.getData("yoo")} words={() => {
					const _settings = FakeData.listify(FakeData.getData("yoo").settings).filter((set, i) => {
						return set.sub === "word_restrition"
					});

					if (_settings[0]) {
						return FakeData.nullify(_settings[0]['value']).split(",");
					} else {
						return []
					}
				}}
					userFilter={currentUser.id === null ? false : currentUser}
					isHome={currentUser.id !== null ? false : true}
					key={currentUser.id !== null ? currentUser.user : "all"}
					page={currentUser.id !== null ? currentUser : { id: FakeData.getData("yoo").id, type: "F" }}
					teams={currentUser.id !== null ? [] : FakeData.listify(FakeData.getData("teamIds"))}
					friends={currentUser.id !== null ? [] : FakeData.listify(FakeData.getData("friendIds"))}
					clubs={currentUser.id !== null ? [] : FakeData.listify(FakeData.getData("clubIds"))}
					leagues={currentUser.id !== null ? [] : FakeData.listify(FakeData.getData("leagueIds"))}
					institutions={currentUser.id !== null ? [] : FakeData.listify(FakeData.getData("instIds"))}
					styles={{
						normalPosts: { marginBottom: "10px" },
						gmcPosts: { marginBottom: "10px" }
					}}
					user={user}
					userType={"F"}
					posts={posts}
				>
					<EmptyState
						style={{ background: "#fff" }}
						isShown={
							FakeData.listify(posts).length === 0 &&
								!this.state.isLoadingPosts
								? true
								: false
						}
						text="No posts were found!"
						icon="filter_hdr"
					/>
					<LoadingState
						style={{ background: "#fff" }}
						isShown={this.state.isLoadingPosts}
						text={"Loading"}
					/>
				</GlobalTMFeeds>
			</div>,
			<div key={"three"}
				style={{
					display: activeView === "Chats" ? "block" : "none",
					width: "100%",
					height: "100vh"
				}}
			>
				<ChatView
					isHomeEmbed={true}
					onChatDelete={(bool = true) => {
						this.state.chat.chat = this._Chats()[0]
							? this._Chats()[0]
							: null;
						this.setState({
							chat: this.state.chat
						});
					}}
					isCreateChat={isCreateChat}
					isLoading={isLoading}
					key={
						!chat
							? "null-chat"
							: chat.isEmail
								? "email-" + chat.id
								: "chat-" + chat.id
					}
					chat={chat}
					chatType={
						activeFilter === "Parents"
							? "parent"
							: FakeData.inArray(activeFilter, ["Groups", "Teams"])
								? "event"
								: "timeline"
					}
					isNewGroup={
						FakeData.inArray(activeFilter, ["Groups"]) ? true : false
					}
					onChatSelect={this.onChatSelect}
					onUserSelect={this.onUserSelect}
				/>
			</div>
		]

	}

	renderLeftView = () => {
		const {
			user,
			isGoingLive,
			isShowinQuickLinks,
			currentFilter,
			currentView,
			currentUser,
			createLinks,
			posts,
			groups,
			offset,
			shortcuts,
			isDeletingSC,
			shortCutToDel,
			isAddingEvent,
			isAddingNormalEvent,
			eventType,
			isAddingGroup,
			activeView
		} = this.state;
		const {
			chat,
			activeFilter,
			isLoading,
			isCreateChat,
			activeChatIndex
		} = this.state.chat;
		return(
			<div className="_home_page_left">
					<div className="home-user-card">
						<Link
							to={{
								pathname: "/profile/" + user.username,
								search: "?sInit=about"
							}}
							className="home-user-card-cover-hq"
						>
							{this.is &&
								user.bg_image !== "server/media/" && (
									<img
										src={user.bg_image}
										onLoad={e => {
											//console.log(e.target,window.Vibrant)
											var vibrant = new window.Vibrant(e.target);
											var swatches = vibrant.swatches();
											for (var swatch in swatches) {
												if (
													swatches.hasOwnProperty(swatch) &&
													swatches[swatch] &&
													swatch === "Vibrant"
												) {
													//console.log(swatch, swatches[swatch].getHex(), swatches[swatch].getTitleTextColor())
													//const style = FakeData.getProfileStyle(swatches[swatch].getHex(), swatches[swatch].getTitleTextColor(), swatches[swatch].getBodyTextColor());
													//console.log(style)
													const _style = {
														".home-user-card-content-head-author-over > span:first-child": {
															color: swatches[swatch].getTitleTextColor()
														},

														".home-user-card-content-head-author-over > span:last-child": {
															color: swatches[swatch].getTitleTextColor()
														}
													};
													this.setStyle(_style);
													break;
												}
											}
										}}
									/>
								)}
							{this.is && user.bg_image === "server/media/" && <img />}
							<img />
							<div className="home-user-card-content-head-over">
								<img src={user.image} />
								<div className="home-user-card-content-head-author-over">
									<span>{user.name}</span>
									<span>{user.username}</span>
								</div>
							</div>
						</Link>
						<div className="home-user-card-content-hq">
							<div className="home-user-card-content-label">
								<span>{currentView}</span>
								<div
									className="home-user-card-content-label-opts"
									ref={"opts-ctx"}
									tabIndex={"0"}
								>
									<i className="material-icons">more_vert</i>
									<div className="home-user-card-content-label-opts-ctx">
										{activeView !== "Timeline" && (
											<span
												onClick={() => {
													this.refs["opts-ctx"].blur();
													this.state.chat.isCreateChat = true;
													this.setState({ chat: this.state.chat });
												}}
											>
												Create Chat
                      </span>
										)}
										{activeView !== "Timeline" && (
											<span
												onClick={() => {
													this.refs["opts-ctx"].blur();
												}}
											>
												Create Chat Group
                      </span>
										)}
										{activeView === "Timeline" && (
											<span
												onClick={() => {
													this.setState({ isAddingNormalEvent: true });
													this.refs["opts-ctx"].blur();
												}}
											>
												Create Event
                      </span>
										)}
										{activeView === "Timeline" && (
											<span
												onClick={() => {
													this.setState({ isAddingGroup: true });
													this.refs["opts-ctx"].blur();
												}}
											>
												Create Group
                      </span>
										)}
										{activeView === "Timeline" && (
											<span
												onClick={() => {
													this.refs["opts-ctx"].blur();
													window.location = "/create";
												}}
											>
												Create Page
                      </span>
										)}
										{activeView === "Timeline" && (
											<span
												onClick={() => {
													this.refs["opts-ctx"].blur();
													this.setState({
														isShowinQuickLinks: !isShowinQuickLinks
													});
												}}
											>
												{isShowinQuickLinks ? "Hide Links" : "Quick Links"}
											</span>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
						className="home-user-filters"
						style={{
							marginBottom: 10,
							display: isShowinQuickLinks ? "none" : ""
						}}
					>
						<a
							className={currentView === "Friends" ? "active" : ""}
							onClick={() => this.setCurrentView()}
						>
							<img src="images/who_sees_friends.svg" alt="Friends" />
						</a>
						<a
							className={
								currentView === "Groups" || currentView === "Chat Groups"
									? "active"
									: ""
							}
							onClick={() =>
								this.setCurrentView(
									activeView === "Timeline" ? "Groups" : "Chat Groups"
								)
							}
						>
							<img
								src="images/facebook-group.svg"
								alt="Groups"
								style={{
									background: "#58CC66",
									borderRadius: "100px",
									padding: "2px"
								}}
							/>
						</a>
						<a
							className={currentView === "Teams" ? "active" : ""}
							onClick={() => this.setCurrentView("Teams")}
						>
							<img src="images/who_sees_game.svg" alt="Team" />
						</a>
						{activeView === "Timeline" && (
							<a
								className={currentView === "Clubs" ? "active" : ""}
								onClick={() => this.setCurrentView("Clubs")}
							>
								<img
									src="images/club.svg"
									alt="Clubs"
									style={{
										background: "#f43",
										borderRadius: "100px",
										padding: "2px"
									}}
								/>
							</a>
						)}
						{activeView === "Timeline" && (
							<a
								className={currentView === "Tournaments" ? "active" : ""}
								onClick={() => this.setCurrentView("Tournaments")}
							>
								<img src="images/who_sees_league.svg" alt="League" />
							</a>
						)}
						{activeView === "Timeline" && (
							<a
								className={currentView === "Institutions" ? "active" : ""}
								onClick={() => this.setCurrentView("Institutions")}
							>
								<img
									src="images/institution_icon.svg"
									alt=""
									style={{
										background: "#888",
										borderRadius: "100px",
										padding: "2px"
									}}
								/>
							</a>
						)}
					</div>

					<div
						className="home-user-body-filters"
						style={{
							marginBottom: 10,
							display: isShowinQuickLinks ? "none" : ""
						}}
					>
						<div className="home-user-body-filters-search">
							<i className="material-icons">search</i>
							<input
								placeholder="Search"
								value={currentFilter}
								onChange={e => {
									this.setState({ currentFilter: e.target.value });
								}}
							/>
						</div>

						{activeView !== "Chats" && (
							<div className="home-user-body-filters-ctx">
								{FakeData.nullify("")
									.toLowerCase()
									.indexOf(currentFilter.toLowerCase()) > -1 && (
										<div
											className={"home-user-body-filters-ctx-item"}
											onClick={() => {
												this.setState({
													currentUser: {
														id: null
													}
												});
											}}
										>
											<img src={FakeData.apiURL+"/default_avatar.svg"} />
											<span>{"All"}</span>
										</div>
									)}
								{currentView === "Friends" &&
									activeView === "Timeline" &&
									FakeData.nullify(FakeData.getData("yoo").name)
										.toLowerCase()
										.indexOf(currentFilter.toLowerCase()) > -1 && (
										<div
											className={
												currentUser.id === FakeData.getData("yoo").id &&
													currentUser.type === "F"
													? "home-user-body-filters-ctx-item active"
													: "home-user-body-filters-ctx-item"
											}
											onClick={() => {
												this.setState({
													currentUser: {
														id: FakeData.getData("yoo").id,
														type: "F",
														noPreview: true
													}
												});
											}}
										>
											<img src={FakeData.getData("yoo").image} />
											<span>{"You"}</span>
										</div>
									)}
								{currentView === "Friends" &&
									FakeData.getData("yoo")
										.friends.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["F"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === item.type
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: item
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/profile/" + item.user} />
												</div>
											);
										})}

								{currentView === "Teams" &&
									this.getTeams()
										.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["T"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === "T"
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: {
																id: item.id,
																type: "T",
																image: item.image,
																name: item.name
															}
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/team/" + item.id} />
												</div>
											);
										})}

								{currentView === "Groups" &&
									FakeData.getData("yoo")
										.groups.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["Q"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === "Q"
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: {
																id: item.id,
																type: "Q",
																user: item.user,
																image: item.image,
																name: item.name
															}
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/group/" + item.user} />
												</div>
											);
										})}

								{currentView === "Clubs" &&
									FakeData.getData("yoo")
										.clubs.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["C"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === "C"
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: {
																id: item.id,
																type: "C",
																user: item.hash,
																image: item.image,
																name: item.name
															}
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/club/" + item.hash} />
												</div>
											);
										})}

								{currentView === "Institutions" &&
									FakeData.getData("yoo")
										.institutions.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["I"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === "I"
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: {
																id: item.id,
																type: "I",
																user: item.hash,
																image: item.image,
																name: item.name
															}
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/institution/" + item.hash} />
												</div>
											);
										})}

								{currentView === "Tournaments" &&
									FakeData.getData("yoo")
										.leagues.filter((item, i) => {
											return (
												FakeData.nullify(item.name)
													.toLowerCase()
													.indexOf(currentFilter.toLowerCase()) > -1
											);
										})
										.map((item, i) => {
											const block = FakeData.getBlocked(this, false, ["L"], ["block"]);
											if (FakeData.inArray(item.id, block)) {
												return null;
											}
											return (
												<div
													key={i}
													className={
														currentUser.id === item.id &&
															currentUser.type === "L"
															? "home-user-body-filters-ctx-item active"
															: "home-user-body-filters-ctx-item"
													}
													onClick={() => {
														this.setState({
															currentUser: {
																id: item.id,
																type: "L",
																user: item.hash,
																image: item.image,
																name: item.name
															}
														});
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
													<_Link href={"/tournament/" + item.hash} />
												</div>
											);
										})}
							</div>
						)}
						{activeView === "Chats" && (
							<div className="home-user-body-filters-ctx">
								<ChatList onNewMessage={(msg) => {
									this.setChat(msg)
								}}
									filter={currentFilter}
									activeChatIndex={activeChatIndex}
									isHomeEmbed={true}
									isCreateChat={isCreateChat}
									isLoading={isLoading}
									setCreatingChatView={this.setCreatingChatView}
									key={activeFilter + this._Chats().length}
									newChat={this.state.chat}
									activeChatIndex={this.state.activeChatIndex}
									onUserSelect={this.onUserSelect}
									onChatSelect={this.onChatSelect}
									chats={this._Chats()}
									filters={this.state.filters}
									activeFilter={this.state.activeFilter}
									onFilterChange={this.setFilters}
								/>
							</div>
						)}
					</div>

					{isShowinQuickLinks && (
						<LinkLongBox
							initState={isShowinQuickLinks}
							onClick={() => {
								this.setState({ isShowinQuickLinks: false });
							}}
							title="Quick links"
						>
							{shortcuts.map((item, i) => {
								return (
									<div className="user-shortcut" key={item.id}>
										<img src={item.user.image} />
										<span>
											<Link
												to={{
													pathname: "/" + item.type + "/" + item.ref,
													search: item.search
												}}
											>
												{item.name}
											</Link>
										</span>
										<i
											className="material-icons"
											onClick={() => {
												this.setState({
													isDeletingSC: true,
													shortCutToDel: item
												});
											}}
										>
											delete
                    </i>
									</div>
								);
							})}
						</LinkLongBox>
					)}

					{this.is && (
						<LinkLongBox initState={false} title="Pages">
							{user.pages.map((item, i) => {
								return (
									<div className="user-shortcut" key={item.id}>
										<img src={item.image} />
										<span>
											<Link
												to={{
													pathname:
														"/" +
														item.stype.toLowerCase() +
														"/" +
														(item.type !== "T" ? item.user : item.id),
													search: "?sInit=about"
												}}
											>
												{item.name}
											</Link>
										</span>
									</div>
								);
							})}
						</LinkLongBox>
					)}

					{FakeData.listify(user.pages).length > 10000000000 && (
						<LinkLongBox initState={false} title="Create Event">
							<div
								className="create-sh-cut"
								onClick={() => {
									this.setState({ isAddingNormalEvent: true });
								}}
							>
								<i className="material-icons">event</i>
								<span>Public Event</span>
							</div>
							<div
								className="create-sh-cut"
								onClick={() => {
									this.setState({ isAddingEvent: true, eventType: "Meeting" });
								}}
							>
								<i className="material-icons">event</i>
								<span>Meeting Event</span>
							</div>
							<div
								className="create-sh-cut"
								onClick={() => {
									this.setState({ isAddingEvent: true, eventType: "Social" });
								}}
							>
								<i className="material-icons">event</i>
								<span>Social Event</span>
							</div>
							{FakeData.listify(user.pages).length > 0 && (
								<div
									className="create-sh-cut"
									onClick={() => {
										this.setState({
											isAddingEvent: true,
											eventType: "Training"
										});
									}}
								>
									<i className="material-icons">event</i>
									<span>Training Event</span>
								</div>
							)}
						</LinkLongBox>
					)}

					{FakeData.listify(user.pages).length ===
						10000000000 /*def value is 0*/ && (
							<LinkLongBox initState={false} title="Create Event">
								<div
									className="create-sh-cut"
									onClick={() => {
										this.setState({ isAddingNormalEvent: true });
									}}
								>
									<i className="material-icons">event</i>
									<span>Public Event</span>
								</div>
								<div
									className="create-sh-cut"
									onClick={() => {
										this.setState({ isAddingEvent: true, eventType: "Meeting" });
									}}
								>
									<i className="material-icons">event</i>
									<span>Meeting Event</span>
								</div>
								<div
									className="create-sh-cut"
									onClick={() => {
										this.setState({ isAddingEvent: true, eventType: "Social" });
									}}
								>
									<i className="material-icons">event</i>
									<span>Social Event</span>
								</div>
							</LinkLongBox>
						)}

					{this.is && (
						<LinkLongBox initState={false} title="Groups">
							<div
								className="create-sh-cut"
								onClick={() => {
									this.setState({ isAddingGroup: true });
								}}
							>
								<i className="material-icons">add</i>
								<span>Create New</span>
							</div>
							{groups.map((item, i) => {
								return (
									<Link
										to={{
											pathname: "/group/" + item.user,
											search: "?sInit=timeline"
										}}
										key={item.id}
										className="group-list-hm-pg"
									>
										<Avatar
											text={item.name}
											style={{
												backgroundColor: item.color,
												color: FakeData.getLuminance(item.color)
											}}
										/>
										<span className="group-list-hm-pg-name">{item.name}</span>
										{item.notices.length > 0 && (
											<span className="group-list-hm-pg-count">
												{item.notices.length}
											</span>
										)}
									</Link>
								);
							})}
						</LinkLongBox>
					)}

					{this.is && (
						<LinkLongBox initState={false} title="Training Material">
							<div
								className="create-sh-cut"
								onClick={() => {
									this.setState({ isAddingMaterial: true });
								}}
							>
								<i className="material-icons">add</i>
								<span>Create New</span>
							</div>
						</LinkLongBox>
					)}

					{!this.is && (
						<LinkLongBox initState={false} title="Create Page">
							{createLinks.map((item, i) => {
								return (
									<Link className="create-sh-cut" replace key={i} to={item.to}>
										<i className="material-icons">add</i>
										<span>
											Create {item.key} {item.key === "Game" ? "" : "Profile"}
										</span>
									</Link>
								);
							})}
						</LinkLongBox>
					)}
				</div>
		)
	}

	render = () => {
		const {
			user,
			isGoingLive,
			isShowinQuickLinks,
			currentFilter,
			currentView,
			currentUser,
			createLinks,
			posts,
			groups,
			offset,
			shortcuts,
			isDeletingSC,
			shortCutToDel,
			isAddingEvent,
			isAddingNormalEvent,
			eventType,
			isAddingGroup,
			activeView
		} = this.state;
		const {
			chat,
			activeFilter,
			isLoading,
			isCreateChat,
			activeChatIndex
		} = this.state.chat;
		if (user.id === null) {
			return (
				<div className="gmc-before">
					<div className="loader">
						<h1>Please wait...</h1>
						<div className="spinner" />
					</div>
				</div>
			);
		}

		posts.sort((a, b) => {
			return b.timestamp - a.timestamp;
		});

		return (
			<div
				data-page="home"
				className="home-page sp-flex-width"
				style={{ width: FakeData.width, zIndex: 0, padding: "10px 10px" }}
			>
				{this.renderLeftView()}	
				<Media query="(min-width: 1500px)">
					{matches =>
						matches ? (
							<div
							className="home-page-mid"
							style={{
								width: activeView === "Timeline" ? "calc( 100% - 40vw )" : "100%"
							}}
						>
							{this.renderMidView()}
						</div>
						) : (
							<div
							className="home-page-mid"
							style={{
								width: activeView === "Timeline" ? "calc( 100% - 47vw )" : "100%"
							}}
						>
							{this.renderMidView()}
						</div>
						)
					}
				</Media>
				{activeView === "Timeline" && (
					<div className="home-page-right">
						{activeView === "Timeline" &&
							currentUser.id !== null &&
							!currentUser.noPreview && (
								<div className="home-page-right-kn-cards">
									{currentUser.type === "F" && (
										<UserKnowledgeGraph
											key={currentUser.id}
											user={currentUser}
										/>
									)}
									{currentUser.type === "T" && (
										<TeamKnowledgeGraph
											key={currentUser.id}
											team={currentUser}
										/>
									)}
									{currentUser.type === "C" && (
										<ClubKnowledgeGraph
											key={currentUser.id}
											club={currentUser}
										/>
									)}
									{currentUser.type === "I" && (
										<InstitutionKnowledgeGraph
											key={currentUser.id}
											club={currentUser}
										/>
									)}
									{currentUser.type === "L" && (
										<TournKnowledgeGraph
											key={currentUser.id}
											tourn={currentUser}
										/>
									)}
									{currentUser.type === "Q" && (
										<GroupKnowledgeGraph
											key={currentUser.id}
											group={currentUser}
										/>
									)}
								</div>
							)}
						<LiveGames
							class={"league"}
							style={{ margin: "0px 0px 10px 0px" }}
						/>
						<WeatherWidget />
						<div
							className="next-game-view"
							style={{
								width: "100%",
								position: "relative",
								minHeight: 0,
								marginTop: 0
							}}
						>
							<UpcominComingGames class={"league"} />
						</div>

						<EventsWidget
							user={{ id: FakeData.getData("yoo").id, type: "F" }}
							teams={[]}
						/>

						<LinkLongBox initState={true} title="Ads" />
					</div>
				)}
				{isDeletingSC &&
					shortCutToDel !== null && (
						<ConfirmModal
							message="Are you sure you want to remove this shortcut?<br/>"
							isOpen={isDeletingSC}
							data={shortCutToDel}
							onOkay={data => {
								this.deleteShortcut(data);
							}}
							onCancel={() => {
								this.setState({
									isDeletingSC: false,
									shortCutToDel: null
								});
							}}
						/>
					)}
				{isAddingEvent &&
					eventType !== null && (
						<AddEventModal
							isOpen={isAddingEvent}
							onAfterAdd={() => {
								this.setState({ isAddingEvent: false, eventType: null });
							}}
							type={eventType}
							eventToType={"F"}
							eventToID={user.id}
						/>
					)}

				{isAddingGroup && (
					<CreateGroupPopUp
						isOpen={isAddingGroup}
						onClose={data => {
							this.setState({ isAddingGroup: false });
						}}
					/>
				)}
				{isAddingNormalEvent && (
					<CreateNormalEvent
						toId={FakeData.getData("yoo").id}
						toType={"F"}
						users={FakeData.getData("yoo").friends}
						isOpen={isAddingNormalEvent}
						onClose={data => {
							this.setState({ isAddingNormalEvent: false });
						}}
					/>
				)}
				{isGoingLive && (
					<VideoStreamTV
						onClose={() => {
							this.setState({ isGoingLive: false });
						}}
						user={{
							name: user.name,
							image: user.image,
							id: user.id,
							type: "F"
						}}
						isLive={false}
						style={{
							zIndex: 9999,
							background: 'url(".././images/stadium_background.jpg")'
						}}
					/>
				)}
			</div>
		);
	};
}

const UserCard = props => {
	const { user } = props;
	return (
		<div className="home-user-card">
			<div className="home-user-card-cover">
				<img src={user.bg_image} />
			</div>
			<div className="home-user-card-content">
				<div className="home-user-card-content-head">
					<img src={user.image} />
					<div className="home-user-card-content-head-author">
						<span>{user.name}</span>
						<span>{user.username}</span>
					</div>
				</div>
				<div className="home-user-card-content-body">
					<Link
						to={{
							pathname: "/profile/" + user.username,
							search: "?sInit=photos"
						}}
						className="home-user-card-content-body-author"
					>
						<span>Photos</span>
						<span>{FakeData.listify([]).length}</span>
					</Link>
					<Link
						to={{
							pathname: "/profile/" + user.username,
							search: "?sInit=videos"
						}}
						className="home-user-card-content-body-author"
					>
						<span>Videos</span>
						<span>{FakeData.listify([]).length}</span>
					</Link>
					<Link
						to={{
							pathname: "/profile/" + user.username,
							search: "?sInit=friends"
						}}
						className="home-user-card-content-body-author"
					>
						<span>Friends</span>
						<span>{FakeData.listify(user.friends).length}</span>
					</Link>
				</div>
			</div>
		</div>
	);
};

const _Link = ({ href }) => {
	return (
		<div className={"home-user-body-link"}>
			<a href={href}><i className="material-icons">launch</i></a>
		</div>
	)
}

class LinkLongBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: !this.props.initState ? false : true
		};
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		const { isExpanded } = this.state;
		return (
			<div className="home-user-shortcuts">
				<span
					onClick={() => {
						this.setState({ isExpanded: isExpanded ? false : true });
						if (this.props.onClick) {
							this.props.onClick();
						}
					}}
				>
					{this.props.title}
					<i className="material-icons">
						{!isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_up"}
					</i>
				</span>
				{isExpanded && <div>{this.props.children}</div>}
			</div>
		);
	}
}

export class WeatherWidget extends Component {
	constructor(props) {
		super(props);
		this.state = {
			coords: { longitude: 0, latitude: 0 },
			error: false,
			data: null,
			isExpanded: true
		};
	}

	componentDidMount() {
		this.getPerm_();
	}

	getPerm_ = () => {
		if ("geolocation" in navigator) {
			const _that = this;
			navigator.geolocation.getCurrentPosition(
				function (position) {
					var _coords = {
						latitude: position.coords.latitude,
						longitude: position.coords.longitude
					};
					//console.log(position)
					_that.setState({ coords: _coords, error: false });
					_that.getData();
				},
				function () {
					//FakeData.alert("Failed to retrieve your location, weather widget and other features may not be available")
					_that.setState({ error: true });
				}
			);
		} else {
			this.setState({ error: true });
		}
	};

	getData = () => {
		const _that = this;
		const { coords } = this.state;
		const geodata = FakeData.getData("yoo").coord;
		const _coords = coords;
		const _url =
			"http://api.openweathermap.org/data/2.5/weather?lat=" +
			_coords.latitude +
			"&lon=" +
			_coords.longitude +
			"&appid=195d4355748813317d816ae2da8c08ae";
		FakeData.post(
			_url,
			{},
			{
				success(res) {
					//console.log(res)
					_that.setState({ data: res });
				},
				error() { }
			}
		);
	};

	render = () => {
		const { isExpanded, data, error } = this.state;
		if (error) {
			return null;
		}

		if (data === null) {
			return (
				<div className="weather-widget">
					<span>Loading weather</span>
				</div>
			);
		}

		return (
			<div className="weather-widget">
				<div
					className="weather-widget-head"
					onClick={() =>
						this.setState({ isExpanded: isExpanded ? false : true })
					}
				>
					<span>{data.name}</span>
					<img
						src={
							"https://openweathermap.org/themes/openweathermap/assets/vendor/owm/img/widgets/" +
							data.weather[0].icon +
							".png"
						}
					/>
					<i className="material-icons">
						{!isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_up"}
					</i>
				</div>
				{isExpanded && (
					<div className="weather-widget-body">
						<span>{(data.main.temp - 273.15).toFixed(2)}°C</span>
						<div>
							<span>Details</span>
							<span>{data.weather[0].description.capitalize()}</span>
							<span>Wind {data.wind.speed} m/s</span>
						</div>
					</div>
				)}
			</div>
		);
	};
}

export class EventsWidget extends Component {
	constructor(props) {
		super(props);
		this.date = new Date();
		this.date.setMinutes(
			this.date.getMinutes() - this.date.getTimezoneOffset()
		);
		this.state = {
			events: [],
			months: FakeData.months,
			days: FakeData.days,
			current: {
				date: this.date.getDate(),
				year: this.date.getFullYear(),
				month: FakeData.months[this.date.getMonth()],
				index: this.date.getMonth(),
				lastDay: this.getLastDay(this.date.getDate(), this.date.getMonth())
			},
			dates: this.genDays(this.date.getFullYear(), this.date.getMonth() + 1),
			date: ""
		};
	}

	componentDidMount() {
		FakeData.mountState("event-widget", true);
		this._isMounted = true;
		this.getEvents();
	}

	componentWillUnmount() {
		FakeData.mountState("event-widget", false);
		this._isMounted = false;
	}

	getLastDay(year, month) {
		var year = this.date.getFullYear();
		var date = new Date(year, this.date.getMonth() + 1, 0);
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		return date.getDate();
	}

	prev(int) {
		if (this.state.current.index === 0) {
			var year = parseInt(this.state.current.year) - 1;
			this.setState({
				current: {
					date: this.date.getDate(),
					year: year,
					month: FakeData.months[11],
					index: 11,
					lastDay: this.getLastDay(year, 12)
				},
				dates: this.genDays(year, 13)
			});
		} else {
			var year = this.state.current.year;
			this.setState({
				current: {
					date: this.date.getDate(),
					year: year,
					month: FakeData.months[int],
					index: int,
					lastDay: this.getLastDay(year, int)
				},
				dates: this.genDays(year, int + 1)
			});
		}
	}

	next(int) {
		if (this.state.current.index === 11) {
			var year = parseInt(this.state.current.year) + 1;
			this.setState({
				current: {
					date: this.date.getDate(),
					year: year,
					month: FakeData.months[0],
					index: 0,
					lastDay: this.getLastDay(year, 1)
				},
				dates: this.genDays(year, 2)
			});
		} else {
			var year = this.state.current.year;
			this.setState({
				current: {
					date: this.date.getDate(),
					year: year,
					month: FakeData.months[int],
					index: int,
					lastDay: this.getLastDay(year, int)
				},
				dates: this.genDays(year, int + 1)
			});
		}
	}

	genDays(year, month, isUpdate) {
		var date = new Date(year, month, 0);
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		var firstDay = new Date(year, month - 1, 1);
		firstDay.setMinutes(firstDay.getMinutes() - firstDay.getTimezoneOffset());
		var startDay = firstDay.getDay();
		const arr = [];
		for (let i = 0; i < date.getDate() + startDay; i++) {
			if (i < startDay) {
				arr.push({
					id: null,
					value: i,
					year: year,
					month: month
				});
			} else {
				const bool = Boolean(isUpdate);
				const events = [];
				arr.push({
					id: i,
					value: i - startDay,
					year: year,
					month: month
				});
			}
		}

		return arr;
	}

	getEvents() {
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			userToId: this.props.user.id,
			userToType: this.props.user.type,
			teamIds: this.props.teams
		};

		if (!this._isMounted) {
			return;
		}

		FakeData.post("/getEventInvites.php?auth0", dataTo, {
			success: res => {
				if (!_that._isMounted) {
					return;
				}
				res.sort(function (a, b) {
					return b.timestamp - a.timestamp;
				});
				_that.setState({
					events: res
				});

				_that.getEventsID = setTimeout(() => {
					_that.getEvents();
				}, 1000);
			},
			error: err => {
				console.log(err);
			}
		});
	}

	getEventsForDate = (year, month, day) => {
		const list = [];
		const { events } = this.state;
		events.map((item, i) => {
			if (item.year === year && item.month === month && item.day === day) {
				list.push(item);
			}
		});

		return list;
	};

	render = () => {
		const { days, months, dates, events } = this.state;
		return (
			<div className="event-widget">
				<div className="event-widget-head">
					<i
						className="icon left"
						onClick={() => {
							this.prev(this.state.current.index - 1);
						}}
					/>
					<span>
						{this.state.current.month + ", " + this.state.current.year}
					</span>
					<i
						className="icon right"
						onClick={() => {
							this.next(this.state.current.index + 1);
						}}
					/>
				</div>
				<div className="event-widget-sub-head">
					{days.map((item, i) => {
						return <div key={i}>{item.charAt(0)}</div>;
					})}
				</div>
				<div className="event-widget-body">
					{dates.map((item, i) => {
						return (
							<EventWidgetDay
								key={i}
								item={item}
								events={this.getEventsForDate(
									item.year,
									item.month,
									item.value + 1
								)}
							/>
						);
					})}
				</div>
			</div>
		);
	};
}

export class EventWidgetDay extends Component {
	constructor(props) {
		super(props);
		this.state = {
			index: 0,
			filters: ["Game", "Social", "Meeting", "Training", "Normal", "Private"],
			className: ""
		};
	}

	getFiltered(arr, _list) {
		const list = Array();
		FakeData.listify(_list).forEach((item, i) => {
			if (FakeData.inArray(item.type, FakeData.listify(arr))) {
				list.push(item);
			}
		});
		return list;
	}

	render = () => {
		const { item, events } = this.props;
		const { index, filters, className } = this.state;
		const today = FakeData.today().context.dateObj.getDate();
		const y = FakeData.today().context.dateObj.getFullYear();
		const m = FakeData.today().context.dateObj.getMonth() + 1;
		const _events = this.getFiltered(filters, events);
		return (
			<div
				data-value={item.value + 1}
				className={
					item.id === null ? "past" : events.length > 0 ? "has-events" : ""
				}
				tabIndex={0}
				style={{
					backgroundColor:
						item.value + 1 === today && item.year === y && item.month === m
							? "#374353"
							: ""
				}}
			>
				<span
					style={{
						color:
							item.value + 1 === today && item.year === y && item.month === m
								? "#fff"
								: ""
					}}
				>
					{item.id === null ? "" : item.value + 1}
				</span>
				{events.length > 0 &&
					item.id !== null &&
					_events[index] && (
						<div className="event-widget-day-pop">
							<div className={"event-widget-day-pop-head " + className}>
								<i className="material-icons">event</i>
								<div
									dangerouslySetInnerHTML={{
										__html:
											'<marquee scrollamount="2">' +
											_events[index].name +
											"</marquee><span>" +
											_events[index].type +
											"</span>"
									}}
								/>
								<div className="notices-badge" style={{ marginTop: "8px" }}>
									{this.getFiltered(["Social", "Meeting"], events).length > 0 &&
										events.length > 1 && (
											<span
												className="events"
												style={{ margin: "0px 2px" }}
												onClick={() => {
													this.setState({
														filters: ["Social", "Meeting"],
														className: "events",
														index: 0
													});
												}}
											>
												{this.getFiltered(["Social", "Meeting"], events).length}
											</span>
										)}
									{this.getFiltered(["Training"], events).length > 0 &&
										events.length > 1 && (
											<span
												className="_training"
												style={{ margin: "0px 2px" }}
												onClick={() => {
													this.setState({
														filters: ["Training"],
														className: "_training",
														index: 0
													});
												}}
											>
												{this.getFiltered(["Training"], events).length}
											</span>
										)}
									{this.getFiltered(["Game"], events).length > 0 &&
										events.length > 1 && (
											<span
												className="games"
												style={{ margin: "0px 2px" }}
												onClick={() => {
													this.setState({
														filters: ["Game"],
														className: "",
														index: 0
													});
												}}
											>
												{this.getFiltered(["Game"], events).length}
											</span>
										)}
									{this.getFiltered(
										["Game", "Social", "Meeting", "Training"],
										events
									).length > 1 && (
											<span
												className="all"
												style={{ margin: "0px 2px" }}
												onClick={() => {
													this.setState({
														filters: ["Game", "Social", "Meeting", "Training"],
														className: "",
														index: 0
													});
												}}
											>
												{
													this.getFiltered(
														["Game", "Social", "Meeting", "Training"],
														events
													).length
												}
											</span>
										)}
								</div>
							</div>
							{_events.length > 1 && (
								<div className={"event-widget-day-pop-ctrl " + className}>
									{_events.map((item, i) => {
										return (
											<span
												className={index === i ? "active" : ""}
												key={item.id}
												onClick={() => this.setState({ index: i })}
											/>
										);
									})}
								</div>
							)}
							<div className="event-widget-day-pop-body">
								<div>
									<span>Venue</span>
									<span>{_events[index].place}</span>
								</div>
								<div>
									<span>Date</span>
									<span>{_events[index].date}</span>
								</div>
								<div>
									<span>Time</span>
									<span>
										{isNaN(
											FakeData.toMyTimezone(
												_events[index].fullTimestamp
											).getHours()
										)
											? "not set"
											: FakeData.toMyTimezone(
												_events[index].fullTimestamp
											).getHours() +
											":" +
											FakeData.toMyTimezone(
												_events[index].fullTimestamp
											).getMinutes() +
											(FakeData.toMyTimezone(
												_events[index].fullTimestamp
											).getHours() > 11
												? "PM"
												: "AM")}
									</span>
								</div>
							</div>
						</div>
					)}
			</div>
		);
	};
}

const AddEventModal = props => {
	return (
		<Modal isOpen={props.isOpen} onClose={props.onAfterAdd}>
			<div style={{ width: "1000px", padding: "20px" }}>
				<EventViewCreateForm1
					type={props.type}
					eventToType={props.eventToType}
					eventToID={props.eventToID}
					onAfterAdd={props.onAfterAdd}
				/>
			</div>
		</Modal>
	);
};

const AddGroupModal = props => {
	return (
		<EventGroupChatCreate
			eventToType={props.eventToType}
			eventToID={props.eventToID}
			isOpen={props.isOpen}
			onClose={props.onClose}
		/>
	);
};

export class CreateNormalEvent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			event: {
				host: { id: null, name: "" },
				file: null,
				name: "",
				location: null,
				type: "Normal",
				startDate: null,
				startTime: null,
				endDate: null,
				endTime: null,
				description: null,
				invites: []
			},
			errors: {
				host: false,
				file: false,
				name: false,
				location: false,
				startDate: false,
				startTime: false,
				endDate: false,
				endTime: false,
				description: false,
				invites: false
			}
		};
	}

	onSelectHost = (host, el) => {
		const { event } = this.state;
		event.host = host;
		this.setState({ event });
		el.blur();
	};

	onSelectType = (type, el) => {
		const { event } = this.state;
		event.type = type;
		this.setState({ event });
		el.blur();
	};

	onFilesPicked(files) {
		const _that = this;
		const { event } = this.state;
		const file = files[0];
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			event.file = newFile;

			_that.setState({
				event
			});

			this.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile = file => {
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("userId", FakeData.getData("yoo").id);
		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.event.file.progress = percent;
				_that.state.errors.file = percent < 95 ? true : false;
				_that.setState({
					event: _that.state.event,
					errors: _that.state.errors
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				data.oldUrl = file.url;
				_that.state.event.file = data;
				_that.state.errors.file = false;
				_that.setState({
					event: _that.state.event,
					errors: _that.state.errors
				});
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id
		);
		ajax.send(formdata);
	};

	saveEvent = () => {
		const { event, errors } = this.state;
		const { toId, toType, users } = this.props;
		event.host = event.host.id !== null ? event.host : FakeData.getData("yoo");
		this.setState({ event });
		if (event.file === null) {
			errors.file = true;
			this.setState({ errors });
			return;
		}
		if (event.name === "" || event.name === null) {
			errors.name = true;
			this.setState({ errors });
			return;
		}

		if (event.location === "" || event.location === null) {
			errors.location = true;
			this.setState({ errors });
			return;
		}

		if (event.startDate === "" || event.startDate === null) {
			errors.startDate = true;
			this.setState({ errors });
			return;
		}

		if (event.startTime === "" || event.startTime === null) {
			errors.startTime = true;
			this.setState({ errors });
			return;
		}

		let date = new Date(event.startDate + " " + event.startTime + ":00");
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		event["fullStartTimestamp"] = date.toUTCString();

		if (event.endDate === "" || event.endDate === null) {
			errors.endDate = true;
			this.setState({ errors });
			return;
		}

		if (event.endTime === "" || event.endTime === null) {
			errors.endTime = true;
			this.setState({ errors });
			return;
		}

		date = new Date(event.endDate + " " + event.endTime + ":00");
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		event["fullEndTimestamp"] = date.toUTCString();

		if (event.invites.length === 0) {
			errors.invites = true;
			this.setState({ errors });
			return;
		}

		if (event.description === "" || event.description === null) {
			errors.description = true;
			this.setState({ errors });
			return;
		}

		const _that = this;
		const dataTo = {
			user: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			userTo: {
				id: toId,
				type: toType
			},
			event
		};

		FakeData.post(
			"/createEvent.php?auth0",
			dataTo,
			{
				success(res) {
					if (res.error) {
						FakeData.alert("Couldn't save event, please try again later!");
					} else {
						FakeData.alert("Group Created Successfully!");
						_that.props.onClose();
					}
				},
				error(err) {
					FakeData.alert("Couldn't save event, please try again later!");
				}
			},
			true,
			"",
			e => { }
		);
	};

	render = () => {
		const { event, errors } = this.state;
		const { toId, toType, users } = this.props;
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose()}>
				<div
					className="add-place"
					style={{
						width: "40vw",
						height: "85vh",
						overflowX: "hidden",
						overflowY: "auto"
					}}
				>
					<h1>Create an event</h1>
					<CreateNormalEventField
						title="Event Host"
						subtitle="Select a friend who will host this event"
						rightObject={
							<EventHostPicker
								host={event.host}
								users={users ? users : FakeData.getData("yoo").friends}
								onSelectHost={this.onSelectHost.bind(this)}
							/>
						}
					/>
					<CreateNormalEventField
						title="Event Type"
						subtitle="Select event type, default is public. Select Private to restrict users from seeing this event from the saerch page"
						rightObject={
							<EventTypePicker
								value={event.type === "Private" ? event.type : "Public"}
								onSelect={this.onSelectType.bind(this)}
							/>
						}
					/>
					<CreateNormalEventField
						title="Basic Info"
						subtitle="This info will also appear in calender details for this event"
					>
						<EField title="Event Photo">
							<div
								style={{
									width: "100%",
									height: "150px",
									background: "#374353",
									position: "relative",
									display: "flex",
									alignItems: "center",
									justifyContent: "center"
								}}
							>
								<img
									className={errors.file ? "error" : ""}
									src={event.file !== null ? event.file.url : ""}
									style={{
										height: "100%",
										width: "100%",
										objectFit: "cover",
										objectPosition: "center",
										opacity: event.file !== null ? 1 : 0
									}}
								/>
								<div
									style={{ position: "absolute" }}
									className={errors.file ? "error" : ""}
								>
									<i className="material-icons" style={{ color: "#FFF" }}>
										{event.file !== null && event.file.progress < 95
											? "slow_motion_video"
											: "camera_alt"}
									</i>
									<input
										type={"file"}
										accept="image/*"
										disabled={
											event.file !== null && event.file.progress < 95
												? true
												: false
										}
										onChange={e => this.onFilesPicked(e.target.files)}
										style={{
											position: "absolute",
											left: 0,
											top: 0,
											right: 0,
											bottom: 0,
											opacity: 0
										}}
									/>
								</div>
							</div>
						</EField>
						<EField title="Event Name">
							<input
								placeholder=""
								onChange={e => {
									event.name = e.target.value;
									errors.name = false;
									this.setState({ errors, event });
								}}
								style={{ width: "100%" }}
								className={errors.name ? "normal-input error" : "normal-input"}
							/>
						</EField>
						<EField title="Location">
							<LocationPicker
								inputClass={
									errors.location ? "normal-input error" : "normal-input"
								}
								value={event.location}
								user={FakeData.getData("yoo")}
								places={
									FakeData.getData("yoo") && FakeData.getData("yoo").placesLived
										? FakeData.getData("yoo").placesLived.others
										: []
								}
								onSetPlace={data => {
									event.location = data.name;
									event["coord"] = data.coord;
									errors.location = false;
									this.setState({ errors, event });
								}}
							/>
						</EField>
						<EField title="Start">
							<div
								className={
									errors.start ? "date-time-input invalid" : "date-time-input"
								}
							>
								<span className={errors.startDate ? "error" : ""}>
									<input
										placeholder="dd/mm/yyyy"
										ref={e =>
											FakeData.makeDatePicker(e, evt => {
												const _that = this;
												event.startDate = evt.target.value;
												errors.startDate = false;
												_that.setState({ event, errors });
											})
										}
									/>
									<i className="material-icons">event</i>
								</span>
								<span className={errors.startTime ? "error" : ""}>
									<input
										placeholder="hh:mm"
										ref={e =>
											FakeData.makeTimePicker(e, evt => {
												const _that = this;
												event.startTime = evt.target.value;
												errors.startTime = false;
												_that.setState({ event, errors });
											})
										}
									/>
									<i className="material-icons">query_builder</i>
								</span>
							</div>
						</EField>
						<EField title="End">
							<div
								className={
									errors.end ? "date-time-input invalid" : "date-time-input"
								}
							>
								<span className={errors.endDate ? "error" : ""}>
									<input
										placeholder="dd/mm/yyyy"
										ref={e =>
											FakeData.makeDatePicker(e, evt => {
												const _that = this;
												event.endDate = evt.target.value;
												errors.endDate = false;
												_that.setState({ event, errors });
											})
										}
									/>
									<i className="material-icons">event</i>
								</span>
								<span className={errors.endTime ? "error" : ""}>
									<input
										placeholder="hh:mm"
										ref={e =>
											FakeData.makeTimePicker(e, evt => {
												const _that = this;
												event.endTime = evt.target.value;
												errors.endTime = false;
												_that.setState({ event, errors });
											})
										}
									/>
									<i className="material-icons">query_builder</i>
								</span>
							</div>
						</EField>
					</CreateNormalEventField>
					<CreateNormalEventField
						title="Details"
						subtitle="Let people know what type of event you're hosting and what to expect"
					>
						<EField title="Invite Friends">
							<EventInvitesPicker
								users={users}
								error={errors.invites}
								onChange={data => {
									event.invites = data;
									errors.invites = false;
									this.setState({ event, errors });
								}}
							/>
						</EField>
						<EField title="Description">
							<textarea
								placeholder=""
								className={
									errors.description ? "normal-input error" : "normal-input"
								}
								style={{ width: "100%", resize: "none", height: "100px" }}
								onChange={e => {
									const _that = this;
									event.description = e.target.value;
									errors.description = false;
									_that.setState({ event, errors });
								}}
							/>
						</EField>
					</CreateNormalEventField>
					<button onClick={this.saveEvent.bind(this)}>Save</button>
				</div>
			</Modal>
		);
	};
}

class EventHostPicker extends Component {
	state = {};

	inSelection = (user, users) => {
		let bool = false;
		for (var i = 0; i < users.length; i++) {
			if (users[i].id === user.id) {
				bool = true;
				break;
			}
		}

		return bool;
	};

	render = () => {
		const props = this.props;
		const { users } = this.props;
		return (
			<div className="evt-host-picker" ref="rootElem" tabIndex={0}>
				<div className="evt-host-picker-head">
					<img
						src={
							props.host.id !== null
								? props.host.image
								: FakeData.getData("yoo").image
						}
					/>
					<span>
						{props.host.id !== null
							? props.host.name
							: FakeData.getData("yoo").name}
					</span>
					<i className="material-icons">keyboard_arrow_down</i>
				</div>
				<div className="evt-host-picker-body">
					{props.host.id !== null &&
						(props.host.id !== FakeData.getData("yoo").id ||
							!this.inSelection(FakeData.getData("yoo"), users)) && (
							<div
								onClick={() =>
									props.onSelectHost(
										FakeData.getData("yoo"),
										this.refs.rootElem
									)
								}
							>
								<img src={FakeData.getData("yoo").image} />
								<span>{FakeData.getData("yoo").name}</span>
							</div>
						)}
					{FakeData.listify(
						users ? users : FakeData.getData("yoo").friends
					).map((item, i) => {
						if (props.host.id === item.id) {
							return null;
						}

						if (FakeData.getData("yoo").id === item.id) {
							return null;
						}
						return (
							<div
								key={item.id + "_" + i}
								onClick={() => props.onSelectHost(item, this.refs.rootElem)}
							>
								<img src={item.image} />
								<span>{item.name}</span>
							</div>
						);
					})}
				</div>
			</div>
		);
	};
}

class EventTypePicker extends Component {
	render = () => {
		const props = this.props;
		return (
			<div className="evt-host-picker" ref="rootElem" tabIndex={0}>
				<div className="evt-host-picker-head">
					<span style={{ padding: "0px 10px" }}>{props.value}</span>
					<i className="material-icons">keyboard_arrow_down</i>
				</div>
				<div className="evt-host-picker-body">
					<div onClick={() => props.onSelect("Normal", this.refs.rootElem)}>
						<span style={{ padding: "0px 10px" }}>{"Public"}</span>
					</div>
					<div onClick={() => props.onSelect("Private", this.refs.rootElem)}>
						<span style={{ padding: "0px 10px" }}>{"Private"}</span>
					</div>
				</div>
			</div>
		);
	};
}

export const EField = props => {
	return (
		<div className="hm-create-evt-fld-input">
			<span style={{ ...props.lblStyle }}>{props.title}</span>
			<div>{props.children}</div>
		</div>
	);
};

class CreateNormalEventField extends Component {
	constructor(props) {
		super(props);
	}

	render = () => {
		const { rightObject } = this.props;
		return (
			<div className="hm-create-evt-fld">
				<div className="hm-create-evt-fld-head">
					<div className="hm-create-evt-fld-head-1">
						<h4>{this.props.title}</h4>
						<span>{this.props.subtitle}</span>
					</div>
					{this.props.rightObject && (
						<div className="hm-create-evt-fld-head-2">{rightObject}</div>
					)}
				</div>
				{this.props.children && (
					<div className="hm-create-evt-fld-body">{this.props.children}</div>
				)}
			</div>
		);
	};
}

class EventInvitesPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filter: "",
			users: [],
			isFocus: false
		};
	}

	onChange = e => {
		this.setState({ filter: e.target.value });
	};

	filterData = () => {
		const { filter } = this.state;
		const { users } = this.props;
		if (filter === "") {
			return [];
		}
		const list = FakeData.listify(
			users ? users : FakeData.getData("yoo").friends
		).filter(item => {
			return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
		});

		return list;
	};

	add = user => {
		const { users } = this.state;
		if (this.inSelection(user, users)) {
		} else {
			users.push(user);
			this.setState({ users });
		}

		this.props.onChange(users);
	};

	remove = user => {
		const { users } = this.state;
		const index = users.findIndex(item => item.id === user.id);
		users.splice(index, 1);
		this.setState({ users });
	};

	inSelection = (user, users) => {
		let bool = false;
		for (var i = 0; i < users.length; i++) {
			if (users[i].id === user.id) {
				bool = true;
				break;
			}
		}

		return bool;
	};

	render = () => {
		const { error } = this.props;
		const { users, filter, isFocus } = this.state;
		return (
			<div
				className={error ? "event-invite-pk error" : "event-invite-pk"}
				tabIndex={0}
			>
				<span className="event-invite-pk-input">
					<input
						placeholder="Search friend"
						tabIndex={1}
						value={filter}
						onChange={this.onChange.bind(this)}
					/>
					{filter !== "" && (
						<i
							className="material-icons"
							onClick={() => this.setState({ filter: "" })}
						>
							close
            </i>
					)}
					<i className="material-icons">search</i>
				</span>
				<div
					className="event-invite-pk-list"
					style={{ display: this.filterData().length > 0 ? "" : "none" }}
					tabIndex={0}
				>
					{this.filterData().map((item, i) => {
						if (FakeData.getData("yoo").id === item.id) {
							return null;
						}

						return (
							<div
								key={i}
								className={
									this.inSelection(item, users)
										? "event-invite-pk-list-item active"
										: "event-invite-pk-list-item"
								}
							>
								<img src={item.image} />
								<span>{item.name}</span>
								{!this.inSelection(item, users) && (
									<button onClick={() => this.add(item)}>Invite</button>
								)}

								{this.inSelection(item, users) && (
									<button onClick={() => this.remove(item)}>Undo</button>
								)}
							</div>
						);
					})}
				</div>
			</div>
		);
	};
}

class CreateGroupPopUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			group: {
				name: null,
				description: null,
				members: [],
				file: null,
				privacy: 1
			},
			errors: {
				name: false,
				members: false,
				description: false,
				file: false
			}
		};
	}

	onFilesPicked(files) {
		const _that = this;
		const { group } = this.state;
		const file = files[0];
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			group.file = newFile;

			_that.setState({
				group
			});

			this.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile = file => {
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("userId", FakeData.getData("yoo").id);
		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.group.file.progress = percent;
				_that.state.errors.file = percent < 95 ? true : false;
				_that.setState({
					group: _that.state.group,
					errors: _that.state.errors
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				data.oldUrl = file.url;
				_that.state.group.file = data;
				_that.state.errors.file = false;
				_that.setState({
					group: _that.state.group,
					errors: _that.state.errors
				});
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id
		);
		ajax.send(formdata);
	};

	save = () => {
		const { group, errors } = this.state;
		if (group.file === null) {
			errors.file = true;
			this.setState({ errors });
			return;
		}
		if (group.name === "" || group.name === null) {
			errors.name = true;
			this.setState({ errors });
			return;
		}

		if (group.members.length === 0) {
			errors.members = true;
			this.setState({ errors });
			return;
		}

		if (group.description === "" || group.description === null) {
			errors.description = true;
			this.setState({ errors });
			return;
		}

		const _that = this;
		const dataTo = {
			userTo: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			group
		};

		//console.log(dataTo)

		FakeData.post(
			"/createGroupForum.php?auth0",
			dataTo,
			{
				success(res) {
					if (res.error) {
						FakeData.alert("Couldn't save event, please try again later!");
					} else {
						FakeData.alert("Group Created Successfully!");
						this.props.onClose();
					}
				},
				error(err) {
					FakeData.alert("Couldn't save event, please try again later!");
				}
			},
			true,
			"",
			e => { }
		);
	};

	render = () => {
		const { group, errors } = this.state;
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose()}>
				<div className="add-place" style={{ width: "40vw" }}>
					<h1>Create Group</h1>
					<CreateNormalEventField
						title="Basic Info"
						subtitle="This info will appear in search results and as part group banner"
					>
						<EField title="Group Photo">
							<div
								style={{
									width: "100%",
									height: "150px",
									background: "#374353",
									position: "relative",
									display: "flex",
									alignItems: "center",
									justifyContent: "center"
								}}
							>
								<img
									className={errors.file ? "error" : ""}
									src={group.file !== null ? group.file.url : ""}
									style={{
										height: "100%",
										width: "100%",
										objectFit: "cover",
										objectPosition: "center",
										opacity: group.file !== null ? 1 : 0
									}}
								/>
								<div
									style={{ position: "absolute" }}
									className={errors.file ? "error" : ""}
								>
									<i className="material-icons" style={{ color: "#FFF" }}>
										{group.file !== null && group.file.progress < 95
											? "slow_motion_video"
											: "camera_alt"}
									</i>
									<input
										type={"file"}
										accept="image/*"
										disabled={
											group.file !== null && group.file.progress < 95
												? true
												: false
										}
										onChange={e => this.onFilesPicked(e.target.files)}
										style={{
											position: "absolute",
											left: 0,
											top: 0,
											right: 0,
											bottom: 0,
											opacity: 0
										}}
									/>
								</div>
							</div>
						</EField>
						<EField title="Group Name">
							<input
								placeholder=""
								onChange={e => {
									group.name = e.target.value;
									errors.name = false;
									this.setState({ errors, group });
								}}
								style={{ width: "100%" }}
								className={errors.name ? "normal-input error" : "normal-input"}
							/>
						</EField>
						<EField title="Group Privacy">
							<PublicityPicker
								style={{ justifyContent: "flex-start" }}
								tags={[
									{ key: 1, icon: "public", name: "Public" },
									{ key: 0, icon: "lock", name: "Closed" },
									{ key: 2, icon: "lock", name: "Secret" }
								]}
								onChange={e => {
									const _that = this;
									//console.log(e)
									group.privacy = e;
									_that.setState({ group });
								}}
							/>
						</EField>
					</CreateNormalEventField>
					<CreateNormalEventField
						title="More Info"
						subtitle="Add members and group description here"
					>
						<EField title="Group Memebers">
							<EventInvitesPicker
								error={errors.members}
								onChange={data => {
									group.members = data;
									errors.members = false;
									this.setState({ group, errors });
								}}
							/>
						</EField>
						<EField title="Group Description">
							<textarea
								placeholder=""
								className={
									errors.description ? "normal-input error" : "normal-input"
								}
								style={{ width: "100%", resize: "none", height: "100px" }}
								onChange={e => {
									const _that = this;
									group.description = e.target.value;
									errors.description = false;
									_that.setState({ group, errors });
								}}
							/>
						</EField>
					</CreateNormalEventField>
					<button onClick={this.save.bind(this)}>Save</button>
				</div>
			</Modal>
		);
	};
}



// WEBPACK FOOTER //
// ./src/pages/Home.js